import { ExportColumn } from '../../../../../interfaces/ExportColumn';

export const baseColumnsITApps: ExportColumn[] = [
  {
    key: 'name',
    header: 'IT Application',
    type: 'text',
    width: 50,
  },
  {
    key: 'impactedByLocalizedEvent',
    header: 'Impacted by Localized Event?',
    type: 'boolean',
    width: 35,
  },
  {
    key: 'redundancyAvailable',
    header: 'Redundancy Available?',
    type: 'boolean',
  },
  {
    key: 'rampUpTime',
    header: 'Ramp-Up Time (hours)',
    type: 'number',
  },
  {
    key: 'contactFirstName',
    header: 'Internal Contact First Name',
    type: 'text',
    width: 30,
  },
  {
    key: 'contactLastName',
    header: 'Internal Contact Last Name',
    type: 'text',
    width: 30,
  },
  {
    key: 'email',
    header: 'Internal Contact Email',
    type: 'email',
    width: 30,
  },
];

export const baseColumnsHardware: ExportColumn[] = [
  {
    key: 'name',
    header: 'Hardware',
    type: 'text',
    width: 50,
  },
  {
    key: 'countNeeded',
    header: 'Count Needed',
    type: 'number',
  },
  {
    key: 'leadTime',
    header: 'Lead Time (months)',
    type: 'number',
  },
  {
    key: 'costPerUnit',
    header: 'Cost Per Unit',
    type: 'money',
  },
  {
    key: 'contactFirstName',
    header: 'Internal Contact First Name',
    type: 'text',
    width: 30,
  },
  {
    key: 'contactLastName',
    header: 'Internal Contact Last Name',
    type: 'text',
    width: 30,
  },
  {
    key: 'email',
    header: 'Internal Contact Email',
    type: 'email',
    width: 30,
  },
];
